/**
 * myTVS Custom Phone-OTP Auth + Account Dashboard
 *
 * Login page:   /pages/account-login  (templates/page.mytvs-login.liquid)
 * Account page: /pages/my-account     (templates/page.mytvs-account.liquid)
 *
 * API: https://wiz.mytvs.com/mytvs/customer/*
 * All requests: POST + application/x-www-form-urlencoded + Bearer token
 *
 * window.MYTVS_API_BASE  — set in each template
 * window.MYTVS_API_TOKEN — static bearer token set in each template
 * window.MYTVS_LOGIN_PAGE / window.MYTVS_ACCOUNT_PAGE — page URLs
 */
(function () {
  'use strict';

  var API_BASE    = (window.MYTVS_API_BASE  || '').replace(/\/$/, '');
  var API_TOKEN   = window.MYTVS_API_TOKEN  || '';
  var LOGIN_PAGE  = window.MYTVS_LOGIN_PAGE  || '/pages/account-login';
  var ACCOUNT_PAGE= window.MYTVS_ACCOUNT_PAGE|| '/pages/my-account';
  var RESEND_SECS = 30;
  var SESSION_KEY = 'mytvs_customer';

  // ---------------------------------------------------------------------------
  // Session — stored in localStorage after verify_otp
  // { customer_id, name, email, mobile }
  // ---------------------------------------------------------------------------
  function getSession() {
    try { return JSON.parse(localStorage.getItem(SESSION_KEY) || 'null'); } catch (e) { return null; }
  }
  function setSession(d)  { localStorage.setItem(SESSION_KEY, JSON.stringify(d)); }
  function clearSession() { localStorage.removeItem(SESSION_KEY); }
  function isLoggedIn()   { return !!getSession(); }

  // ---------------------------------------------------------------------------
  // API — POST + application/x-www-form-urlencoded + Bearer token
  // Response shape: { code: "200", data: ... } or { responsecode: 200, ... }
  // ---------------------------------------------------------------------------
  function api(path, params) {
    var body = new URLSearchParams();
    if (params) {
      Object.keys(params).forEach(function (k) { body.append(k, params[k]); });
    }
    return fetch(API_BASE + path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Bearer ' + API_TOKEN
      },
      body: body.toString()
    }).then(function (r) {
      return r.json().then(function (d) {
        var code = String(d.code || d.responsecode || '');
        if (!r.ok || (code && code !== '200')) {
          return Promise.reject(d);
        }
        return d;
      });
    });
  }

  // ---------------------------------------------------------------------------
  // Utilities
  // ---------------------------------------------------------------------------
  function go(url) { window.location.href = url; }
  function $(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function show(el) { if (el) el.hidden = false; }
  function hide(el) { if (el) el.hidden = true; }
  function err(el, msg) { if (!el) return; el.textContent = msg || ''; el.hidden = !msg; }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function fmtDate(str) {
    if (!str) return '';
    var d;
    // API returns DD-MM-YYYY (e.g. "25-07-2026"), which new Date() can't parse -> build it explicitly
    var m = /^(\d{2})-(\d{2})-(\d{4})$/.exec(String(str).trim());
    if (m) { d = new Date(+m[3], +m[2] - 1, +m[1]); }
    else   { d = new Date(str); }
    if (isNaN(d.getTime())) return str;              // unknown format -> show raw, never "Invalid Date"
    try { return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }); }
    catch (e) { return str; }
  }

  function fmtMoney(amount) {
    if (amount == null || amount === '') return '';
    return '₹' + parseFloat(amount).toLocaleString('en-IN', { minimumFractionDigits: 2 });
  }

  function pillCls(status) {
    var s = (status || '').toLowerCase();
    if (/delivered|fulfilled/.test(s))    return 'mtvs-pill--ok';
    if (/cancel/.test(s))                 return 'mtvs-pill--err';
    if (/pending|cod confirm/.test(s))    return 'mtvs-pill--wait';
    if (/transit|shipped|new order/.test(s)) return 'mtvs-pill--info';
    return 'mtvs-pill--mut';
  }

  function errMsg(e) {
    if (!e) return 'Something went wrong. Please try again.';
    return e.responsemessage || e.message || e.error || 'Something went wrong. Please try again.';
  }

  // Build the shipment-tracking URL for a given AWB (channel_awb).
  // e.g. https://app.mytvs.com/order_tracking/GS7312413692
  function trackUrl(awb) {
    if (!awb) return '';
    var t = window.MYTVS_TRACK_URL || 'https://app.mytvs.com/order_tracking/{order}';
    return t.indexOf('{order}') >= 0
      ? t.replace('{order}', encodeURIComponent(awb))
      : t.replace(/\/+$/, '') + '/' + encodeURIComponent(awb);
  }

  // ---------------------------------------------------------------------------
  // Product image lookup — resolves a line item's image from Shopify's public
  // Storefront predictive-search endpoint (by SKU, then by product title).
  // Fully client-side, no admin token. Results are cached per query.
  // ---------------------------------------------------------------------------
  var _imgCache = {};

  // Add a Shopify CDN width param for a crisp, lightweight thumbnail.
  function cdnThumb(url, px) {
    if (!url) return url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + (px || 160);
  }

  function suggestImage(query, fields) {
    query = (query || '').trim();
    if (!query) return Promise.resolve('');
    var key = fields + '::' + query;
    if (_imgCache[key] !== undefined) return Promise.resolve(_imgCache[key]);
    var qs = 'q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=1' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=' + encodeURIComponent(fields);
    return fetch('/search/suggest.json?' + qs, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ps = ((((d.resources || {}).results) || {}).products) || [];
        var raw = ps.length ? (ps[0].featured_image || ps[0].image || '') : '';
        var img = (raw && typeof raw === 'object') ? (raw.url || '') : (raw || '');
        _imgCache[key] = img || '';
        return _imgCache[key];
      })
      .catch(function () { _imgCache[key] = ''; return ''; });
  }

  // Resolve one line item to an image URL: SKU match first, then title match.
  function resolveItemImage(sku, name) {
    var titleQ = (name || '').split('|')[0].trim() || name || '';
    var chain = Promise.resolve('');
    if (sku)    chain = chain.then(function (u) { return u || suggestImage(sku, 'variants.sku'); });
    if (titleQ) chain = chain.then(function (u) { return u || suggestImage(titleQ, 'title,variants.sku'); });
    return chain;
  }

  // Fill in missing product thumbnails inside a rendered order body.
  function hydrateLineImages(scope) {
    $$('.mtvs-line', scope).forEach(function (el) {
      if (el.getAttribute('data-img')) return;            // already had a direct image
      resolveItemImage(el.getAttribute('data-sku'), el.getAttribute('data-name')).then(function (url) {
        if (!url) return;
        var thumb = el.querySelector('.mtvs-line__thumb');
        if (!thumb) return;
        thumb.innerHTML = '<img src="' + esc(cdnThumb(url, 160)) + '" width="60" height="60" loading="lazy" alt="' +
          esc(el.getAttribute('data-name') || '') + '">';
        thumb.classList.add('is-loaded');
      });
    });
  }

  // ---------------------------------------------------------------------------
  // LOGIN PAGE  (#mauth-step-phone exists on this page)
  // ---------------------------------------------------------------------------
  function initLogin() {
    var stepPhone = $('#mauth-step-phone');
    if (!stepPhone) return;
    if (isLoggedIn()) { go(ACCOUNT_PAGE); return; }

    var phoneState = { phone: '' };

    // ---- Step 1: phone ----
    var phoneForm    = $('#mauth-phone-form');
    var phoneInput   = $('#mauth-phone');
    var phoneErr     = $('#mauth-phone-err');
    var phoneBtnTxt  = $('#mauth-phone-btn-text');
    var phoneBtnSpin = $('#mauth-phone-btn-spinner');
    var phoneSubmit  = $('#mauth-phone-submit');

    phoneForm && phoneForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var raw   = (phoneInput ? phoneInput.value : '').trim();
      var phone = raw.replace(/\D/g, '').slice(-10);
      if (!phone || phone.length < 10) { err(phoneErr, 'Please enter a valid 10-digit mobile number.'); return; }
      err(phoneErr, '');
      phoneSubmit.disabled = true;
      show(phoneBtnSpin); if (phoneBtnTxt) phoneBtnTxt.textContent = 'Sending…';

      api('/mytvs/customer/send_otp', { mobile: phone })
        .then(function () {
          phoneState.phone = phone;
          var disp = $('#mauth-otp-phone-display');
          if (disp) disp.textContent = '+91 ' + phone;
          hide(stepPhone); show($('#mauth-step-otp'));
          startResend();
          var otpIn = $('#mauth-otp-input');
          if (otpIn) otpIn.focus();
        })
        .catch(function (e) {
          var msg = errMsg(e);
          var code = String((e && (e.code || e.responsecode)) || '');
          if (code === '404') msg = 'This mobile number is not registered with myTVS. Please contact help@mytvs.com for support.';
          err(phoneErr, msg);
        })
        .finally(function () {
          phoneSubmit.disabled = false;
          hide(phoneBtnSpin); if (phoneBtnTxt) phoneBtnTxt.textContent = 'Send OTP';
        });
    });

    // ---- Step 2: OTP ----
    var stepOtp    = $('#mauth-step-otp');
    var otpForm    = $('#mauth-otp-form');
    var otpInput   = $('#mauth-otp-input');
    var otpErr     = $('#mauth-otp-err');
    var otpBtnTxt  = $('#mauth-otp-btn-text');
    var otpBtnSpin = $('#mauth-otp-btn-spinner');
    var otpSubmit  = $('#mauth-otp-submit');
    var resendBtn  = $('#mauth-resend-btn');
    var resendCd   = $('#mauth-resend-countdown');
    var resendTimer = null, resendLeft = 0;

    function startResend() {
      resendLeft = RESEND_SECS;
      if (resendBtn) resendBtn.disabled = true;
      if (resendCd) resendCd.textContent = '(' + RESEND_SECS + 's)';
      clearInterval(resendTimer);
      resendTimer = setInterval(function () {
        resendLeft -= 1;
        if (resendCd) resendCd.textContent = resendLeft > 0 ? '(' + resendLeft + 's)' : '';
        if (resendLeft <= 0) { clearInterval(resendTimer); if (resendBtn) resendBtn.disabled = false; }
      }, 1000);
    }

    resendBtn && resendBtn.addEventListener('click', function () {
      err(otpErr, '');
      resendBtn.disabled = true;
      api('/mytvs/customer/send_otp', { mobile: phoneState.phone })
        .then(startResend)
        .catch(function (e) { err(otpErr, errMsg(e)); resendBtn.disabled = false; });
    });

    var backBtn = $('#mauth-otp-back');
    backBtn && backBtn.addEventListener('click', function () {
      clearInterval(resendTimer);
      hide(stepOtp); show(stepPhone);
    });

    otpForm && otpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var otp = (otpInput ? otpInput.value : '').trim();
      if (!otp || otp.length < 4) { err(otpErr, 'Please enter the OTP.'); return; }
      err(otpErr, '');
      otpSubmit.disabled = true;
      show(otpBtnSpin); if (otpBtnTxt) otpBtnTxt.textContent = 'Verifying…';

      api('/mytvs/customer/verify_otp', { mobile: phoneState.phone, otp: otp })
        .then(function (res) {
          var data = res.data || {};
          setSession({
            customer_id: String(data.customer_id || ''),
            name:        data.name   || '',
            email:       data.email  || '',
            mobile:      data.mobile || phoneState.phone
          });
          go(ACCOUNT_PAGE);
        })
        .catch(function (e) {
          var msg = errMsg(e);
          var code = String((e && (e.code || e.responsecode)) || '');
          if (code === '401') msg = 'Invalid or expired OTP. Please try again.';
          err(otpErr, msg);
        })
        .finally(function () {
          otpSubmit.disabled = false;
          hide(otpBtnSpin); if (otpBtnTxt) otpBtnTxt.textContent = 'Verify & Continue';
        });
    });
  }

  // ---------------------------------------------------------------------------
  // ACCOUNT DASHBOARD  (#mauth-dashboard exists on this page)
  // ---------------------------------------------------------------------------
  function initDashboard() {
    var root = $('#mauth-dashboard');
    if (!root) return;

    var session = getSession();
    if (!session || !session.customer_id) { go(LOGIN_PAGE); return; }

    var loadingEl = $('#mauth-dash-loading');
    var contentEl = $('#mauth-dash-content');

    // Populate banner from session — no extra API call needed
    var nameEl  = $('#mauth-banner-name');
    var phoneEl = $('#mauth-banner-phone');
    if (nameEl)  nameEl.textContent  = session.name   || 'there';
    if (phoneEl) phoneEl.textContent = '+91 ' + (session.mobile || '');
    var helloEl = $('#mav2-hello-name');
    if (helloEl) helloEl.textContent = (session.name || 'there').split(' ')[0];
    var initEl = $('#mav2-initial');
    if (initEl) initEl.textContent = ((session.name || 'M').trim().charAt(0) || 'M').toUpperCase();
    hide(loadingEl); show(contentEl);
    activateTab('orders');

    // ---- Tabs ----
    $$('.mauth-tab-btn').forEach(function (btn) {
      btn.addEventListener('click', function () { activateTab(btn.dataset.tab); });
    });

    function activateTab(tab) {
      $$('.mauth-tab-btn').forEach(function (b) { b.classList.toggle('is-active', b.dataset.tab === tab); });
      $$('.mauth-tab-panel').forEach(function (p) { p.hidden = p.dataset.tab !== tab; });
      if (tab === 'orders')  loadOrders();
      if (tab === 'profile') renderProfile();
      if (tab === 'track')   initTrack();
    }

    // ---- v2 quick tiles that switch a tab ----
    $$('[data-mav2-tab]').forEach(function (t) {
      t.addEventListener('click', function () {
        activateTab(t.getAttribute('data-mav2-tab'));
        var p = $('.mauth-tab-panel[data-tab="' + t.getAttribute('data-mav2-tab') + '"]');
        if (p && p.scrollIntoView) p.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // ---- Logout ----
    $$('.mauth-logout-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        clearSession();
        go(LOGIN_PAGE);
      });
    });

    // ====================================================
    // PROFILE TAB — static from session (no edit endpoint)
    // ====================================================
    var profileRendered = false;
    function renderProfile() {
      if (profileRendered) return;
      profileRendered = true;
      var body = $('#mauth-profile-body');
      if (!body) return;
      body.innerHTML =
        '<div class="mtvs-profile">' +
          pField('Name',   session.name   || '—') +
          pField('Mobile', '+91 ' + (session.mobile || '—')) +
          pField('Email',  session.email  || '—') +
        '</div>' +
        '<p class="mtvs-note" style="margin-top:14px;">To update your profile details, please contact ' +
          '<a href="mailto:help@mytvs.com">help@mytvs.com</a></p>';
    }

    function pField(label, value) {
      return '<div class="mtvs-field"><label>' + esc(label) + '</label><div class="v">' + esc(value) + '</div></div>';
    }

    // ====================================================
    // TRACK ORDER TAB
    // ====================================================
    var trackInited = false;
    function initTrack() {
      if (trackInited) return;
      trackInited = true;
      var input = $('#mauth-track-input');
      var btn   = $('#mauth-track-btn');
      var msg   = $('#mauth-track-msg');

      function doTrack() {
        var val = ((input && input.value) || '').trim().replace(/^#/, '');
        if (!val) {
          if (msg) { msg.style.color = '#b42318'; msg.textContent = 'Please enter your AWB / tracking number.'; }
          return;
        }
        var url = trackUrl(val);
        if (url) {
          if (msg) { msg.style.color = '#067647'; msg.textContent = 'Opening tracking…'; }
          window.open(url, '_blank', 'noopener');
        } else {
          if (msg) {
            msg.style.color = '#667085';
            msg.innerHTML = 'Tracking for order <strong>#' + esc(val) + '</strong> will be available soon. ' +
              'For help, email <a href="mailto:help@mytvs.com" style="color:#ef711e;">help@mytvs.com</a>.';
          }
        }
      }

      btn   && btn.addEventListener('click', doTrack);
      input && input.addEventListener('keydown', function (e) { if (e.key === 'Enter') doTrack(); });
      input && input.addEventListener('focus',   function ()  { this.style.borderColor = '#ef711e'; this.style.boxShadow = '0 0 0 3px rgba(239,113,30,.14)'; });
      input && input.addEventListener('blur',    function ()  { this.style.borderColor = '#e7e7e7'; this.style.boxShadow = 'none'; });
    }

    // ====================================================
    // ORDERS TAB
    // ====================================================
    var ordersLoaded = false;

    function loadOrders() {
      if (ordersLoaded) return;
      ordersLoaded = true;
      var container = $('#mauth-orders-body');
      if (!container) return;
      container.innerHTML = '<p class="mtvs-loading-text">Loading orders…</p>';

      api('/mytvs/customer/orders', { customer_id: session.customer_id, mobile: session.mobile })
        .then(function (res) {
          var orders = res.data || res.orders || [];
          if (!Array.isArray(orders)) orders = [];
          renderOrderList(orders, container);
        })
        .catch(function () {
          container.innerHTML = '<p class="mtvs-err-text">Could not load orders. Please try again later.</p>';
        });
    }

    // Renders each order as its own distinct card, expanded by default. The
    // status-coloured left accent + header bar make orders easy to tell apart;
    // the header still toggles the card open/closed.
    function renderOrderList(orders, container) {
      if (!orders.length) {
        container.innerHTML =
          '<div class="mtvs-empty"><i class="feather-shopping-bag"></i>' +
          '<p>No orders yet.</p>' +
          '<a href="/" class="mtvs-btn" style="display:inline-flex;width:auto;padding:0 22px;margin-top:12px;">Shop Now</a></div>';
        return;
      }

      var cards = orders.map(function (o) {
        var orderId = o.order_id || '';
        var status  = o.wiz_status || 'Pending';
        var time    = o.order_time || o.time || '';
        var placed  = fmtDate(o.order_date) + (time ? ', ' + time : '');
        var awb     = o.channel_awb || o.awb || '';
        var turl    = trackUrl(awb);

        return '<div class="mtvs-ocard ' + cardAccent(status) + ' is-open" data-id="' + esc(orderId) + '" data-loaded="0">' +
          '<div class="mtvs-ohead" role="button" tabindex="0" aria-expanded="true">' +
            '<div class="mtvs-ohead__id">' +
              '<span class="mtvs-ohead__eyebrow">Order</span>' +
              '<span class="mtvs-ohead__num">#' + esc(orderId) +
                '<button type="button" class="mtvs-ohead__copy" data-copy="' + esc(orderId) + '" aria-label="Copy order number" title="Copy order number"><i class="feather-copy"></i></button>' +
              '</span>' +
              '<span class="mtvs-ohead__placed">Placed on ' + esc(placed) + '</span>' +
            '</div>' +
            '<div class="mtvs-ohead__tags">' +
              '<span class="mtvs-pill mtvs-pill--icon ' + pillCls(status) + '">' + statusIcon(status) + esc(status) + '</span>' +
              (o.payment_mode ? '<span class="mtvs-ohead__pay">' + esc(o.payment_mode) + '</span>' : '') +
              (awb ? '<a class="mtvs-ohead__track" href="' + esc(turl) + '" target="_blank" rel="noopener" title="Track order ' + esc(awb) + '" aria-label="Track order"><i class="feather-truck"></i></a>' : '') +
            '</div>' +
            '<div class="mtvs-ohead__total">' +
              '<span class="mtvs-ohead__total-lbl">Order Total</span>' +
              '<span class="mtvs-ohead__total-val">' + (o.amount != null ? esc(fmtMoney(o.amount)) : '—') + '</span>' +
            '</div>' +
            '<i class="feather-chevron-down mtvs-chev"></i>' +
          '</div>' +
          '<div class="mtvs-ocard__body"></div>' +
        '</div>';
      }).join('');

      container.innerHTML = '<div class="mtvs-ocards">' + cards + '</div>';
      renderCodAlert(orders);

      $$('.mtvs-ocard', container).forEach(function (card, idx) {
        var head = card.querySelector('.mtvs-ohead');
        if (head) {
          head.addEventListener('click', function (e) {
            // copy btn + track link handle their own clicks (don't toggle the card)
            if (e.target.closest('.mtvs-ohead__copy') || e.target.closest('.mtvs-ohead__track')) return;
            toggleItem(card);
          });
          head.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleItem(card); }
          });
        }
        // The combined /orders API now returns each order's items + shipping +
        // action flags inline, so render the details straight from the list
        // object — no separate per-order details call.
        card.setAttribute('data-loaded', '1');
        renderOrderDetail(orders[idx], card.getAttribute('data-id'), card.querySelector('.mtvs-ocard__body'));
      });

      // Copy-order-number buttons
      $$('.mtvs-ohead__copy', container).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var val = '#' + (btn.getAttribute('data-copy') || '');
          var done = function () {
            var i = btn.querySelector('i');
            if (!i) return;
            var prev = i.className;
            i.className = 'feather-check';
            btn.classList.add('is-copied');
            setTimeout(function () { i.className = prev; btn.classList.remove('is-copied'); }, 1300);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(val).then(done).catch(function () {});
          }
        });
      });
    }

    // v2: banner at the top for COD orders that still need the customer's confirmation.
    function renderCodAlert(orders) {
      var box = $('#mav2-cod');
      if (!box) return;
      var t = function (v) { return v === true || v === 'true' || v === 1 || v === '1'; };
      var due = orders.filter(function (o) { return t((o.header || o).confirm_button); });
      if (!due.length) { box.hidden = true; box.innerHTML = ''; return; }
      var o = due[0], id = o.order_id || (o.header || {}).order_id || '';
      box.innerHTML = '<i class="feather-phone" style="color:#c2410c;font-size:20px"></i>' +
        '<div class="t"><b>' + (due.length > 1 ? due.length + ' COD orders wait for you' : 'COD order #' + esc(id) + ' waits for you') + '</b>' +
        (o.amount != null ? esc(fmtMoney(o.amount)) + ' · ' : '') + 'Confirm to ship it</div>' +
        '<button type="button" class="mav2-cod-go">Review order</button>';
      box.hidden = false;
      var go2 = box.querySelector('.mav2-cod-go');
      go2 && go2.addEventListener('click', function () {
        var card = $('.mtvs-ocard[data-id="' + id + '"]');
        if (!card) return;
        if (!card.classList.contains('is-open')) toggleItem(card);
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
        card.classList.add('mav2-flash');
        setTimeout(function () { card.classList.remove('mav2-flash'); }, 1800);
      });
    }

    // Small leading icon for the status pill.
    function statusIcon(status) {
      var s = (status || '').toLowerCase();
      if (/cancel/.test(s))                            return '<i class="feather-x"></i>';
      if (/delivered|fulfilled/.test(s))               return '<i class="feather-check"></i>';
      if (/transit|shipped/.test(s))                   return '<i class="feather-truck"></i>';
      if (/pending|cod confirm|new order/.test(s))     return '<i class="feather-clock"></i>';
      return '';
    }

    // Status -> card left-accent modifier (mirrors pillCls buckets).
    function cardAccent(status) {
      var s = (status || '').toLowerCase();
      if (/delivered|fulfilled/.test(s))       return 'mtvs-ocard--ok';
      if (/cancel/.test(s))                     return 'mtvs-ocard--err';
      if (/pending|cod confirm/.test(s))        return 'mtvs-ocard--wait';
      if (/transit|shipped|new order/.test(s))  return 'mtvs-ocard--info';
      return 'mtvs-ocard--mut';
    }

    // Expand/collapse one order card (details are already rendered inline).
    function toggleItem(card) {
      if (!card) return;
      var head = card.querySelector('.mtvs-ohead');
      var body = card.querySelector('.mtvs-ocard__body');
      var open = card.classList.toggle('is-open');
      if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (body) body.hidden = !open;
    }

    // Renders full order details INTO an accordion body (no page navigation).
    function renderOrderDetail(o, orderId, body) {
      // API returns: header object + line items array + shipping address
      // Flatten defensively — handle both flat and nested shapes
      var header    = o.header    || o;
      var lineItems = o.line_items || o.items || o.lineItems || o.order_items || [];
      var addr      = o.shipping || o.shipping_address || o.shippingAddress || header.shipping || header.shipping_address || null;

      var amount  = header.amount        || header.total     || '';
      var awb     = header.channel_awb || header.awb || o.channel_awb || '';
      var turl    = trackUrl(awb);

      // Combined /orders API exposes explicit per-order action flags.
      var truthy      = function (v) { return v === true || v === 'true' || v === 1 || v === '1'; };
      var canConfirm  = truthy(header.confirm_button);
      var canCancel   = truthy(header.cancel_button);

      var lines = (Array.isArray(lineItems) ? lineItems : []).map(function (item, idx) {
        var title = item.name || item.title || item.product_name || item.item_name || '';
        var qty   = parseInt(item.qty || item.quantity || 1, 10) || 1;
        // price field name varies across the API — take the first present (unit price)
        var rawPrice = [item.price, item.unit_price, item.selling_price, item.sale_price,
                        item.mrp, item.rate, item.amount, item.line_total, item.total]
                       .find(function (v) { return v != null && v !== ''; });
        var unitNum  = rawPrice != null ? parseFloat(rawPrice) : null;
        var unitTxt  = unitNum != null ? esc(fmtMoney(unitNum)) : '—';
        var totalTxt = unitNum != null ? esc(fmtMoney(unitNum * qty)) : '—';
        var img   = item.image || item.image_url || item.img || '';
        var sku   = item.sku || item.SKU || item.sku_code || '';
        return '<tr>' +
          '<td class="mtvs-itbl__sno">' + (idx + 1) + '</td>' +
          '<td class="mtvs-itbl__prod">' +
            '<div class="mtvs-prod mtvs-line" data-idx="' + idx + '" data-sku="' + esc(sku) + '" data-name="' + esc(title) + '"' +
                 (img ? ' data-img="' + esc(img) + '"' : '') + '>' +
              '<div class="mtvs-line__thumb' + (img ? ' is-loaded' : '') + '">' +
                (img
                  ? '<img src="' + esc(cdnThumb(img, 160)) + '" width="60" height="60" loading="lazy" alt="' + esc(title) + '">'
                  : '<span class="mtvs-line__ph"><i class="feather-image"></i></span>') +
              '</div>' +
              '<div class="mtvs-prod__meta">' +
                '<div class="mtvs-prod__name">' + esc(title) + '</div>' +
                (sku ? '<div class="mtvs-prod__sku">SKU: ' + esc(sku) + '</div>' : '') +
              '</div>' +
            '</div>' +
          '</td>' +
          '<td class="mtvs-itbl__sku" data-label="SKU">' + (sku ? esc(sku) : '—') + '</td>' +
          '<td class="mtvs-itbl__qty" data-label="Qty">' + qty + '</td>' +
          '<td class="mtvs-itbl__unit" data-label="Unit Price">' + unitTxt + '</td>' +
          '<td class="mtvs-itbl__amt" data-label="Total Price">' + totalTxt + '</td>' +
        '</tr>';
      }).join('');

      var codButtons = (canConfirm || canCancel)
        ? '<div style="display:flex;gap:10px;flex-wrap:wrap;margin-top:18px;">' +
            (canConfirm
              ? '<button class="mtvs-btn mauth-detail-confirm" style="width:auto;padding:0 22px;background:#067647;">' +
                  '<span class="mtvs-cod-dtxt">Confirm Order</span>' +
                  '<span class="mauth-spinner mtvs-cod-spin" hidden></span>' +
                '</button>'
              : '') +
            (canCancel
              ? '<button class="mtvs-btn mauth-detail-cancel" style="width:auto;padding:0 22px;background:#fff;color:#b42318;border:1.5px solid #b42318;">' +
                  '<span class="mtvs-cod-dtxt">Cancel Order</span>' +
                  '<span class="mauth-spinner mtvs-cod-spin" hidden style="border-color:rgba(180,35,24,.3);border-top-color:#b42318;"></span>' +
                '</button>'
              : '') +
          '</div>'
        : '';

      var addrHtml = '';
      if (addr) {
        var name = addr.name || (((addr.first_name || addr.firstName || '') + ' ' + (addr.last_name || addr.lastName || '')).trim());
        var phone = addr.contact_no || addr.phone || addr.mobile || addr.contact || '';
        var line1 = addr.address1 || addr.address_1 || addr.address || '';
        var line2 = addr.address2 || addr.address_2 || '';
        var city  = addr.city || '';
        var state = addr.state || addr.province || '';
        var pin   = addr.zip || addr.pincode || addr.postal_code || '';
        var country = addr.country || '';
        var loc1 = esc(line1) + (line2 ? ', ' + esc(line2) : '');
        var loc2 = esc(city) + (state ? ', ' + esc(state) : '') + (pin ? ' ' + esc(pin) : '') + (country ? ', ' + esc(country) : '');
        var initial = (name || 'M').trim().charAt(0).toUpperCase();
        addrHtml =
          '<div class="mtvs-sec">' +
            '<div class="mtvs-sec__label"><i class="feather-map-pin"></i> Delivery Address</div>' +
            '<div class="mtvs-addr">' +
              '<div class="mtvs-addr__avatar">' + esc(initial) + '</div>' +
              '<div class="mtvs-addr__info">' +
                (name ? '<div class="mtvs-addr__name">' + esc(name) + '</div>' : '') +
                (phone ? '<div class="mtvs-addr__phone">' + esc(phone) + '</div>' : '') +
                (loc1 ? '<div class="mtvs-addr__lines">' + loc1 + (loc2.trim() ? ',<br>' + loc2 : '') + '</div>' : '') +
              '</div>' +
            '</div>' +
          '</div>';
      }

      body.innerHTML =
        '<div class="mtvs-odetail">' +
          ((awb || turl)
            ? '<div class="mtvs-ship">' +
                (awb ? '<span class="mtvs-ship__awb">AWB <strong>' + esc(awb) + '</strong></span>' : '') +
                (turl ? '<a href="' + esc(turl) + '" class="mtvs-track-link" target="_blank" rel="noopener"><i class="feather-truck"></i> Track Shipment</a>' : '') +
              '</div>'
            : '') +
          (lines
            ? '<div class="mtvs-sec">' +
                '<div class="mtvs-sec__label"><i class="feather-shopping-bag"></i> Order Items</div>' +
                '<div class="mtvs-itbl-wrap">' +
                  '<table class="mtvs-itbl">' +
                    '<thead><tr>' +
                      '<th>S.No.</th><th>Product</th><th>SKU</th><th>Qty</th><th>Unit Price</th><th>Total Price</th>' +
                    '</tr></thead>' +
                    '<tbody>' + lines + '</tbody>' +
                    (amount
                      ? '<tfoot><tr>' +
                          '<td colspan="5" class="mtvs-itbl__foot-lbl">Order Total</td>' +
                          '<td class="mtvs-itbl__foot-val">' + esc(fmtMoney(amount)) + '</td>' +
                        '</tr></tfoot>'
                      : '') +
                  '</table>' +
                '</div>' +
              '</div>'
            : '<p class="mtvs-note" style="padding:8px 0;">Item details are not available for this order.</p>') +
          addrHtml +
          codButtons +
          orderActions(header, orderId) +
        '</div>';

      hydrateLineImages(body);

      if (canConfirm) bindDetailCod(body, '.mauth-detail-confirm', 'confirm', orderId);
      if (canCancel)  bindDetailCod(body, '.mauth-detail-cancel',  'cancel',  orderId);
    }

    // v2: extra actions per order. Only links to pages that exist today (no fake data).
    function orderActions(header, orderId) {
      var st = String(header.wiz_status || '').toLowerCase();
      var delivered = /delivered|fulfilled/.test(st);
      return '<div class="mav2-acts">' +
        '<button type="button" class="mav2-act q" data-mav2-ask="I need help with my order #' + esc(orderId) + '">' +
          '<i class="feather-message-circle"></i> Ask about this order</button>' +
        (delivered
          ? '<a class="mav2-act" href="https://app.mytvs.com/warranty-registration" target="_blank" rel="noopener"><i class="feather-shield"></i> Register warranty</a>' +
            '<a class="mav2-act" href="/pages/cancellation-returns-refund-policy"><i class="feather-rotate-ccw"></i> Returns</a>'
          : '') +
        '</div>';
    }

    // COD confirm/cancel inside an order's expanded body.
    function bindDetailCod(body, sel, action, orderId) {
      var b = body.querySelector(sel);
      if (!b) return;
      b.addEventListener('click', function () {
        var label = action === 'confirm' ? 'Confirm' : 'Cancel';
        if (!confirm(label + ' order #' + orderId + '?')) return;
        b.disabled = true;
        var dtxt = b.querySelector('.mtvs-cod-dtxt');
        var spin = b.querySelector('.mtvs-cod-spin');
        if (dtxt) dtxt.textContent = label + 'ing…';
        if (spin) spin.hidden = false;
        var path = action === 'confirm' ? '/mytvs/customer/confirm_order' : '/mytvs/customer/cancel_order';
        api(path, { customer_id: session.customer_id, mobile: session.mobile, order_id: orderId })
          .then(function () { ordersLoaded = false; loadOrders(); })
          .catch(function (e) {
            b.disabled = false;
            if (dtxt) dtxt.textContent = label + ' Order';
            if (spin) spin.hidden = true;
            var msg = errMsg(e);
            var code = String((e && (e.code || e.responsecode)) || '');
            if (code === '409') msg = 'This order can no longer be modified.';
            alert(msg);
          });
      });
    }
  }

  // ---------------------------------------------------------------------------
  // v2: Ask myTVS AI chips / box -> open the existing chat widget, prefill the question
  // (customer still presses Send). Widget = <mytvs-support-chat> with an open shadow root.
  // ---------------------------------------------------------------------------
  function chatHost() { var c = document.querySelector('mytvs-support-chat'); return c && c.shadowRoot ? c : null; }
  function chatIsOpen(c) { var ta = c.shadowRoot.querySelector('textarea'); return !!(ta && ta.getClientRects().length); }
  function askAI(text) {
    var n = 0;
    (function tryOpen() {
      var c = chatHost();
      if (!c) { if (++n < 40) setTimeout(tryOpen, 150); return; }
      if (!chatIsOpen(c)) {
        if (typeof window.mytvsOpenChat === 'function') window.mytvsOpenChat();
        else { var l = c.shadowRoot.querySelector('.launcher'); if (l) l.click(); }
      }
      if (!text) return;
      var m = 0;
      (function fill() {
        var ta = c.shadowRoot.querySelector('textarea');
        if (ta && ta.getClientRects().length && !ta.disabled) {
          ta.value = text;
          ta.dispatchEvent(new Event('input', { bubbles: true }));
          try { ta.focus(); ta.setSelectionRange(text.length, text.length); } catch (e) {}
        } else if (++m < 30) { setTimeout(fill, 150); }
      })();
    })();
  }
  window.mytvsAskAI = askAI;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mav2-ask]');
    if (!b) return;
    e.preventDefault();
    askAI(b.getAttribute('data-mav2-ask') || '');
  });
  document.addEventListener('submit', function (e) {
    if (!e.target || e.target.id !== 'mav2-ask-form') return;
    e.preventDefault();
    var inp = document.getElementById('mav2-ask-input');
    var q = inp ? inp.value.trim() : '';
    askAI(q);
    if (inp) inp.value = '';
  });

  // ---------------------------------------------------------------------------
  // Boot
  // ---------------------------------------------------------------------------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initLogin(); initDashboard(); });
  } else {
    initLogin();
    initDashboard();
  }
})();
